import React from 'react'
import {
    Text,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    Button,
    Flex,
} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import {CloseIcon, CheckIcon} from '../../../../components/icons'
import {remCalc} from '../../../../theme/_utils'
import {FormattedMessage} from 'react-intl'

const CancellationConfirmationModal = ({isOpen, onClose}) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered>
            <ModalOverlay />
            <ModalContent maxWidth={remCalc(451)}>
                <ModalHeader>
                    <Flex justifyContent="space-between">
                        <Flex gap={remCalc(17)} alignItems="center">
                            <CheckIcon
                                w={remCalc(24)}
                                h={remCalc(24)}
                                color="text.inverse"
                                backgroundColor="text.success"
                                borderRadius="50%"
                            />
                            <Text fontWeight="normal" textStyle="body-small" color="text.default">
                                <FormattedMessage
                                    id="order_cancelled_confirmation_title"
                                    defaultMessage="Order cancelled"
                                />
                            </Text>
                        </Flex>
                        <CloseIcon data-testid="close-button" onClick={onClose} />
                    </Flex>
                </ModalHeader>
                <ModalBody data-testid="modal-body">
                    <Text fontWeight="normal" textStyle="body-small" color="text.default">
                        <FormattedMessage
                            id="order_cancelled_confirmation_descritpion"
                            defaultMessage="Your order has been successfully canceled. You will receive a confirmation email within 2-4 hours."
                        />
                    </Text>
                </ModalBody>
                <ModalFooter>
                    <Button variant="primary" onClick={onClose} width="100%">
                        <FormattedMessage
                            id="order_cancellation_confirmation_button"
                            defaultMessage="Order Detail"
                        />
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}

CancellationConfirmationModal.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
}

export default CancellationConfirmationModal
